(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/aria-countdown-timer.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/aria-countdown-timer.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const nextMultipleOf10 = num => Math.ceil(num / 10) * 10;

const AriaCountdownTimer = _ref => {
  let startTime = _ref.startTime,
    _ref$showTime = _ref.showTime,
    showTime = _ref$showTime === void 0 ? 280 : _ref$showTime,
    onDone = _ref.onDone,
    children = _ref.children;
  const _React$useState = React.useState(startTime),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    timeLeft = _React$useState2[0],
    setTimeLeft = _React$useState2[1];
  const timeoutRef = React.useRef(null);
  const isDone = React.useRef(false);
  React.useEffect(() => {
    if (timeLeft <= 0 && !isDone.current) {
      isDone.current = true;
      onDone === null || onDone === void 0 || onDone();
    }
  }, [timeLeft, onDone]);
  React.useEffect(() => {
    let expected = Date.now() + 1000;
    const SECOND = 1000;
    const tick = () => {
      setTimeLeft(prev => Math.max(prev - 1, 0));
      const drift = Date.now() - expected;
      expected += SECOND;
      timeoutRef.current = setTimeout(tick, SECOND - drift);
    };
    timeoutRef.current = setTimeout(tick, SECOND);
    return () => clearTimeout(timeoutRef.current);
  }, []);
  return (
    React.createElement(React.Fragment, null, timeLeft <= showTime && React.createElement(React.Fragment, null, timeLeft >= 59 && timeLeft % 60 <= 4 && React.createElement("div", {
      "aria-live": "assertive",
      className: "aria-countdown-timer-screen-reader",
      role: "timer"
    }, "Tid kvar: ".concat(Math.ceil(timeLeft / 60), " minuter")), timeLeft <= 32 && React.createElement("div", null, React.createElement("div", {
      "aria-live": "assertive",
      className: "aria-countdown-timer-screen-reader",
      role: "timer"
    }, "Tid kvar: ".concat(nextMultipleOf10(timeLeft), " sekunder")), React.createElement("div", null, "Tid kvar: ".concat(timeLeft, " s"))), children))
  );
};
svs.playerLoginReact.sharedComponents.AriaCountdownTimer = AriaCountdownTimer;

 })(window);